import React from 'react';
import { withAppContext, getToken } from '@ctsu/loader';
import { withStyles } from '@material-ui/core/styles';
import http from 'helpers/APIHelper';
import { compose } from 'recompose';
import { getSessionByKey } from 'helpers';
import {
  AutoStyles, AutoDownshift
} from './AutoComplete';

class DocumentAutoComplete extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      suggestions: undefined
    };
    this.getSuggestions = this.getSuggestions.bind(this);
    this.downshiftOnChange = this.downshiftOnChange.bind(this);
  }

  getSuggestions(event) {
    if (!event.target.value) {
      return;
    }
    const { context } = this.props;
    const {
      logInfo, logDebug, logError, logFatal
    } = context;
    const token = getToken();

    const { ...loggerInfo } = {
      logInfo, logDebug, logError, logFatal
    };

    http
      .postWithToken(
        `protocol-data-service/${
          getSessionByKey('prt_url_ver')
        }/protocols/document/autocomplete`,
        token,
        loggerInfo,
        event.target.value.trim()
      )
      .subscribe(resp => {
        this.setState({
          suggestions: resp.response
        });
      });
  }

   handleSearchClick = event => {
     event.preventDefault();
     const { suggestions } = this.state;
     if (suggestions && suggestions.length >= 1) {
       this.downshiftOnChange(suggestions[0]);
     }
   }


 handleEnterKeyPress = event => {
   if (event.keyCode === 13) {
     event.preventDefault();
   }
 }

 downshiftOnChange(suggestion) {
   const { onChange } = this.props;
   onChange(suggestion);
 }

 render() {
   const { classes, name } = this.props;
   const { suggestions } = this.state;
   return (
     <div className={`${classes?.root} global-search`}>
       <AutoDownshift
         placeholderText="Search Document Number"
         downshiftOnChange={this.downshiftOnChange}
         classes={classes}
         name={name || "document_number"}
         handleSearchClick={this.handleSearchClick}
         getSuggestions={this.getSuggestions}
         handleEnterKeyPress={this.handleEnterKeyPress}
         suggestions={suggestions}
         suggestionSize="20vh"
       />
       <div className={classes?.divider} />
     </div>
   );
 }
}

export default compose(
  withStyles(AutoStyles),
  withAppContext
)(DocumentAutoComplete);
